
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import '../js/plugins/circular-progress';
import $ from "jquery";
import '../js/plugins/GaugeMeter';
import '../js/plugins/gauge';
export default {
  mounted: function () {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7;

    if (false && self.request.status >= 40) {
      var map = new google.maps.Map(document.getElementById('map'), {
        center: {
          lat: parseFloat(self.request.location_location.latitude),
          lng: parseFloat(self.request.location_location.longitude)
        },
        zoom: 15,
        disableDefaultUI: true,
        mapTypeId: google.maps.MapTypeId.HYBRID,
        styles: [{
          "featureType": "administrative",
          "elementType": "all",
          "stylers": [{
            "saturation": "-100"
          }]
        }, {
          "featureType": "administrative.province",
          "elementType": "all",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [{
            "saturation": -100
          }, {
            "lightness": 65
          }, {
            "visibility": "on"
          }]
        }, {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [{
            "saturation": -100
          }, {
            "lightness": "50"
          }, {
            "visibility": "simplified"
          }]
        }, {
          "featureType": "road",
          "elementType": "all",
          "stylers": [{
            "saturation": "-100"
          }]
        }, {
          "featureType": "road.highway",
          "elementType": "all",
          "stylers": [{
            "visibility": "simplified"
          }]
        }, {
          "featureType": "road.arterial",
          "elementType": "all",
          "stylers": [{
            "lightness": "30"
          }]
        }, {
          "featureType": "road.local",
          "elementType": "all",
          "stylers": [{
            "lightness": "40"
          }]
        }, {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [{
            "saturation": -100
          }, {
            "visibility": "simplified"
          }]
        }, {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [{
            "hue": "#378cff"
          }, {
            "lightness": 0 //-25

          }, {
            "saturation": 0 //-97

          }]
        }, {
          "featureType": "water",
          "elementType": "labels",
          "stylers": [{
            "lightness": -0
          }, {
            "saturation": -0
          }]
        }]
      });

      if (self.request.technician_location) {
        if (map) {
          var marker = new google.maps.Marker({
            position: {
              lat: parseFloat(self.request.technician_location.latitude),
              lng: parseFloat(self.request.technician_location.longitude)
            },
            map: map,
            icon: {
              url: "data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20viewBox%3D%220%200%2016%2024%22%20enable-background%3D%22new%200%200%2016%2024%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E.st0%7Bfill%3A%23378CFF%3B%7D%20.st1%7Bdisplay%3Anone%3Bfill%3A%230E75FF%3B%7D%3C%2Fstyle%3E%3Cg%20transform%3D%22translate%280%20-1028.4%29%22%3E%3Cdefs%3E%3Ccircle%20id%3D%22SVGID_1_%22%20cx%3D%228%22%20cy%3D%221036.4%22%20r%3D%227.5%22%2F%3E%3C%2Fdefs%3E%3CclipPath%20id%3D%22SVGID_2_%22%3E%3Cuse%20xlink%3Ahref%3D%22%23SVGID_1_%22%20overflow%3D%22visible%22%2F%3E%3C%2FclipPath%3E%3Cg%20style%3D%22clip-path%3Aurl%28%23SVGID_2_%29%3B%22%3E%3Cimage%20width%3D%22312%22%20height%3D%22240%22%20xlink%3Ahref%3D%22" + encodeURI(self.request.technician_image_url) + "%22%20transform%3D%22matrix%28.062%200%200%20.062%20-1.707%201028.933%29%22%20overflow%3D%22visible%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3Cpath%20class%3D%22st0%22%20d%3D%22M8%200c-4.4%200-8%203.6-8%208%200%201.4.4%202.8%201%203.9l.3.6%206.6%2011.5%206.6-11.5.3-.5.1-.1c.6-1.2%201-2.5%201-3.9.1-4.4-3.5-8-7.9-8zm0%20.5c4.1%200%207.5%203.4%207.5%207.5s-3.4%207.5-7.5%207.5-7.5-3.4-7.5-7.5%203.4-7.5%207.5-7.5z%22%2F%3E%3Cpath%20class%3D%22st1%22%20d%3D%22M8%203c-2.8%200-5%202.2-5%205s2.2%205%205%205%205-2.2%205-5-2.2-5-5-5zm0%202c1.7%200%203%201.3%203%203s-1.3%203-3%203-3-1.3-3-3%201.3-3%203-3z%22%2F%3E%3C%2Fsvg%3E",
              // This marker is 20 pixels wide by 32 pixels high.
              size: new google.maps.Size(30 * 1.5, 42 * 1.5),
              scaledSize: new google.maps.Size(30 * 1.5, 42 * 1.5),
              // The origin for this image is (0, 0).
              origin: new google.maps.Point(0, 0),
              // The anchor for this image is the base of the flagpole at (0, 32).
              anchor: new google.maps.Point(15 * 1.5, 42 * 1.5)
            }
          });
        }
      }

      if (self.request.location_location) {
        var marker2 = new google.maps.Marker({
          position: {
            lat: parseFloat(self.request.location_location.latitude),
            lng: parseFloat(self.request.location_location.longitude)
          },
          map: map,
          icon: {
            url: 'https://static.app.mitsulift.com/images/map-marker.svg',
            // This marker is 20 pixels wide by 32 pixels high.
            size: new google.maps.Size(30 * 1.5, 42 * 1.5),
            scaledSize: new google.maps.Size(30 * 1.5, 42 * 1.5),
            // The origin for this image is (0, 0).
            origin: new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at (0, 32).
            anchor: new google.maps.Point(15 * 1.5, 42 * 1.5)
          }
        });
      }

      if (marker && marker2) {
        var markers = [marker, marker2]; //some array

        var bounds = new google.maps.LatLngBounds();

        for (var i = 0; i < markers.length; i++) {
          bounds.extend(markers[i].getPosition());
        }

        map.fitBounds(bounds);
      }
    }

    window.initGauge($);
    $(".GaugeMeter").gaugeMeter();

    if (self.request.status >= 40) {
      var gauge1 = Gauge(document.getElementById("gauge1"), {
        dialRadius: 40,
        dialStartAngle: -90,
        dialEndAngle: -90.001,
        value: self.request.response_time,
        max: 60,
        min: 0,
        valueDialClass: "value",
        valueClass: "value-text",
        dialClass: "dial",
        gaugeClass: "gauge",
        showValue: true,
        label: function (value) {
          return "&nbsp;" + self.request.response_time + "'";
        }
      });

      if (self.request.response_time > 60) {
        var remaining = parseInt(self.request.response_time % 60);
        var gauge1_2 = Gauge(document.getElementById("gauge1"), {
          dialRadius: 40,
          dialStartAngle: -90,
          dialEndAngle: -90.001,
          value: remaining,
          max: 60,
          min: 0,
          valueDialClass: "value",
          valueClass: "value-text",
          dialClass: "dial",
          gaugeClass: "gauge absolute-gauge",
          showValue: false
        });
      }

      if (self.request.intervention_time) {
        var gauge2 = Gauge(document.getElementById("gauge2"), {
          dialRadius: 40,
          dialStartAngle: -90,
          dialEndAngle: -90.001,
          value: self.request.intervention_time,
          max: 60,
          min: 0,
          valueDialClass: "value",
          valueClass: "value-text",
          dialClass: "dial",
          gaugeClass: "gauge",
          showValue: true,
          label: function (value) {
            return "&nbsp;" + self.request.intervention_time + "'";
          }
        });

        if (self.request.intervention_time > 60) {
          var remaining2 = parseInt(self.request.intervention_time % 60);
          var gauge2_2 = Gauge(document.getElementById("gauge2"), {
            dialRadius: 40,
            dialStartAngle: -90,
            dialEndAngle: -90.001,
            value: remaining2,
            max: 60,
            min: 0,
            valueDialClass: "value",
            valueClass: "value-text",
            dialClass: "dial",
            gaugeClass: "gauge absolute-gauge",
            showValue: false
          });
        }
      } else {
        var gauge3 = Gauge(document.getElementById("gauge3"), {
          dialRadius: 40,
          dialStartAngle: -90,
          dialEndAngle: -90.001,
          value: 10,
          max: 60,
          min: 0,
          valueDialClass: "value disabled",
          valueClass: "value-text small",
          dialClass: "dial ",
          gaugeClass: "gauge",
          showValue: true,
          label: function (value) {
            return '<tspan x="50" y="40">In</tspan><tspan x="50" y="53">progress</tspan>';
          }
        });
      }
    }

    self.getMyRating(self.request.id);
  },
  data: function () {
    var request = this.$route.context.request;
    console.log(request);
    return {
      request: request,
      myRating: null,
      gaugeSize: Math.min(130, (window.outerWidth - (40 + 16)) / 2)
    };
  },
  methods: {
    showRatingModal() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      app.infiniteScroll.destroy('.request-details-infinite');

      if (self.myRating) {
        return;
      }

      if (self.request.status != 50 && self.request.status != 60) {
        return;
      }

      app.dialog.create({
        title: 'How did ' + self.request.technician_firstname + ' do?',
        content: '<div></div>' + //'<div>Please rate your experience with us</div>'+
        '<div class="rating-bar">' + '<div class="center-content color-theme-primary margin-top">' + '<a href="#" data-stars="1"><i class="icon f7-icons">star</i></a>' + '<a href="#" data-stars="2"><i class="icon f7-icons">star</i></a>' + '<a href="#" data-stars="3"><i class="icon f7-icons">star</i></a>' + '<a href="#" data-stars="4"><i class="icon f7-icons">star</i></a>' + '<a href="#" data-stars="5"><i class="icon f7-icons">star</i></a>' + '</div>' + '<input type="hidden" id="rating" value="0"/>' + '</div>',
        buttons: [{
          text: 'Cancel',
          color: 'red'
        }, {
          text: 'Rate',

          onClick(dialog) {
            var rating = dialog.$el.find("#rating").val();
            console.log("Rating", rating);

            if (rating > 0) {
              if (rating <= 3) {
                app.dialog.create({
                  title: 'Mitsulift',
                  content: "We're sorry you weren't satisfied with your experience!<br/>" + "Your opinion matters to us and a member of our team will contact you shortly.",
                  buttons: [{
                    text: 'I Accept',

                    onClick(dialog) {
                      self.rateService(self.request.id, rating, true);
                    }

                  }, {
                    text: 'Do Not Call',
                    color: 'red',

                    onClick(dialog) {
                      self.rateService(self.request.id, rating, false);
                    }

                  }]
                }).open();
              } else {
                self.rateService(self.request.id, rating, false);
              }
            } else {
              app.dialog.alert("You need to select at least 1 star.");
              self.showRatingModal();
            }
          }

        }],
        verticalButtons: false,
        on: {
          open(dialog) {
            console.log("Modal opened");
            console.log(dialog);
            dialog.$el.find("a").on('click', function () {
              var stars = $$(this).data("stars");
              dialog.$el.find("#rating").val(stars);
              dialog.$el.find("a").each(function (i, v) {
                if ($$(v).data("stars") <= stars) {
                  $$(v).find("i").text("star_fill");
                } else {
                  $$(v).find("i").text("star");
                }
              });
              console.log(stars);
            });
          }

        }
      }).open();
    },

    getMyRating(id) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.$app.request({
        url: Url.to("repair/my-rating"),
        method: "GET",
        data: {
          id: id
        },
        preloader: false,
        indicator: false,
        progress: false,
        success: function (data, status, xhr) {
          console.log(data);
          self.myRating = data;
          self.$update(function () {// if (!self.myRating) {
            //     if (self.request.status == 50 || self.request.status == 60) {
            //         self.showRatingModal();
            //     }
            // }
          });
        }
      });
    },

    rateService: function (id, rating, callme) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      console.log(">>>>>>", this); // self.$app.dialog.confirm('Are you sure you want to rate your experience with us?', function () {

      app.request({
        url: Url.to("repair/rate/" + id),
        method: "POST",
        preloader: false,
        progress: true,
        data: {
          rating: rating,
          follow_up: callme ? 1 : 0
        },
        success: function (data, status, xhr) {
          $$(".rating-widget").removeClass("rating-1 rating-2 rating-3 rating-4 rating-5").addClass("rating-" + rating);
          self.getMyRating(self.request.id); //Instead of toast, show modal with write review
          // app.toast.create({
          //     text: 'Thank you for your feedback!',
          //     closeTimeout: 2000,
          // }).open();

          app.dialog.create({
            title: 'Thanks for your feedback',
            text: 'You can also write a review',
            content: '<div class="rating-widget rating-' + rating + '">' + '   <div></div>' + '   <i class="icon material-icons">star</i>' + '   <i class="icon material-icons">star</i>' + '   <i class="icon material-icons">star</i>' + '   <i class="icon material-icons">star</i>' + '   <i class="icon material-icons">star</i>' + '</div>' + '<div class="list no-hairlines no-margin">' + '   <li class="item-content item-input item-input-outline no-padding-horizontal">' + '      <div class="item-inner no-padding-horizontal">' + '        <div class="item-input-wrap">' + '          <textarea id="input-review" rows="6" class="bg-color-white" placeholder="Write a review (optional)"></textarea>' + '          <span class="input-clear-button"></span>' + '        </div>' + '      </div>' + '    </li>' + '</div>',
            buttons: [{
              text: 'Send Review',

              onClick(dialog) {
                var review = dialog.$el.find("#input-review").val();
                console.log("input-review", review);
                app.request({
                  url: Url.to("repair/review/" + id),
                  method: "POST",
                  preloader: false,
                  progress: true,
                  data: {
                    review: review
                  },
                  success: function (data, status, xhr) {
                    app.toast.create({
                      text: 'Review send successfully!',
                      closeTimeout: 2000
                    }).open();
                  }
                });
              }

            }, {
              text: 'Skip',
              color: 'red'
            }],
            verticalButtons: true
          }).open();
        }
      }); // });
    },

    viewReport() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      var reportUrl = self.request.report_url;
      app.methods.previewPdfDocument(reportUrl, {
        close: () => {
          self.showRatingModal();
        }
      }); // if (window.cordova) {
      //     cordova.InAppBrowser.open(reportUrl, '_system', 'location=yes');
      // } else {
      //     window.open(reportUrl, "_system")
      // }
    },

    reloadRequestData() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      app.request({
        url: Url.to("repair/request-details/" + self.request.id),
        preloader: true,
        progress: false,
        success: function (data, status, xhr) {
          self.request = data;
          self.$update();
        }
      });
    }

  },
  id: 'd024ca3f84',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page no-toolbar navbar-extra-large" data-name="request-details">\n        <div class="navbar navbar-large navbar-extra-large">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back icon-only">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">Repair service</div>\n                <div class="right">\n                </div>\n                <div class="title-large">\n                    <div class="title-large-text">\n                        Notifications\n                        <div class="subtitle-text">Repair service</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="page-content request-details-infinite infinite-scroll-content" @infinite="showRatingModal">\n            ';
      r += Template7Helpers.js_if.call(ctx_1, "this.request.status != 50 && this.request.status != 60 && this.request.status != 35", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="block large-content-block">\n                <p style="font-size: 18px" class="text-color-primary">\n                    ';
          r += c(ctx_2.request.status_message, ctx_2);
          r += '\n\n                    <!--                    ';
          r += Template7Helpers.js_if.call(ctx_2, "this.request.status == 10", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '-->\n                    <!--                    Your mitsulift team is reviewing your request right now.-->\n                    <!--                    A technician will be informed and dispatched to your site -->\n                    <!--                    according to your requested schedule-->\n                    <!--                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '-->\n\n                    <!--                    ';
          r += Template7Helpers.js_if.call(ctx_2, "this.request.status == 20", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '-->\n                    <!--                    ';
              r += c(ctx_3.request.technician, ctx_3);
              r += ' was assigned to your request.-->\n                    <!--                    Awaiting technician confirmation-->\n                    <!--                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '-->\n\n                    <!--                    ';
          r += Template7Helpers.js_if.call(ctx_2, "this.request.status == 30", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '-->\n                    <!--                    ';
              r += c(ctx_3.request.technician, ctx_3);
              r += ' is on his way to your location right now.-->\n                    <!--                    Technician will be on-site in approximately-->\n                    <!--                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '-->\n\n                    <!--                    ';
          r += Template7Helpers.js_if.call(ctx_2, "this.request.status == 40", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '-->\n                    <!--                    ';
              r += c(ctx_3.request.technician, ctx_3);
              r += ' is solving the breakdown right now.-->\n                    <!--                    You will be notified once the service is complete-->\n                    <!--                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '-->\n                </p>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            ';
      r += Template7Helpers.js_if.call(ctx_1, "this.request.status == 35", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.request.eta_hh_mm, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n            <div class="block large-content-block bg-color-primary text-color-white padding-vertical-half">\n                <p style="font-size: 18px" class="no-margin">\n                    ';
              r += c(ctx_3.request.status_message, ctx_3);
              r += '\n                </p>\n                <div class="block timer-block no-padding no-hairlines">\n                    <p class="no-margin">\n                        <a href="#"><i class="icon material-icons" style="opacity: 0">autorenew</i></a>\n                        ';
              r += c(ctx_3.request.eta_hh_mm_ss, ctx_3);
              r += '\n                        <a href="#" @click="reloadRequestData"><i class="icon material-icons color-white">autorenew</i></a>\n                    </p>\n                    <div class="text-align-center">Estimated arrival time</div>\n                </div>\n            </div>\n            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n\n\n\n            ';
      r += Template7Helpers.js_if.call(ctx_1, "this.request.status >= 40", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="block">\n                <div class="row">\n                    <div class="col-100 medium-25"></div>\n                    <div class="col-45 medium-20 text-align-center padding-horizontal-half">\n                        <div id="gauge1" class="gauge-container"></div>\n                        <h3 class="text-align-center no-margin text-color-primary">Response Time</h3>\n                    </div>\n                    <div class="col-45 medium-20 text-align-center padding-horizontal-half">\n                        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.request.intervention_time, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <div id="gauge2" class="gauge-container"></div>\n                        ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <div id="gauge3" class="gauge-container"></div>\n                        ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        <h3 class="text-align-center no-margin text-color-primary">Intervention Time</h3>\n                    </div>\n                    <div class="col-100 medium-25"></div>\n                </div>\n                <div class="row display-none">\n                    <div class="col-50 text-align-center">\n                        <div class="gauge-container">\n                            <div class="GaugeMeter text-color-primary"\n                                 data-text="';
          r += c(ctx_2.request.response_time, ctx_2);
          r += '\'"\n                                 data-size="';
          r += c(ctx_2.gaugeSize, ctx_2);
          r += '"\n                                 data-width="25"\n                                 data-percent="';
          r += c(ctx_2.request.response_time, ctx_2);
          r += '"\n                                 data-label=" "\n                                 data-style="Full"\n                                 data-stripe="0"\n                                 data-animationstep="0"\n\n                                 data-animate_text_colors="1"\n                                 data-animate_gauge_colors="1"\n                                 data-color="#388BFF"\n                                 data-back="#fafafa"\n                                 data-theme="Red-Gold-Green">\n                            </div>\n                        </div>\n                        <h4 class="text-align-center no-margin text-color-primary">Response Time</h4>\n                    </div>\n                    <div class="col-50 text-align-center">\n                        <div class="gauge-container">\n                            ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.request.intervention_time, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <div class="GaugeMeter text-color-primary"\n                                 data-text="';
              r += c(ctx_3.request.intervention_time, ctx_3);
              r += '\'"\n                                 data-size="';
              r += c(ctx_3.gaugeSize, ctx_3);
              r += '"\n                                 data-width="25"\n                                 data-percent="';
              r += c(ctx_3.request.intervention_time, ctx_3);
              r += '"\n                                 data-label=" "\n                                 data-style="Full"\n                                 data-stripe="0"\n                                 data-animationstep="3"\n\n                                 data-animate_text_colors="1"\n                                 data-animate_gauge_colors="1"\n                                 data-color="#388BFF"\n                                 data-back="#fafafa"\n                                 data-theme="Red-Gold-Green">\n                            </div>\n                            ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <div class="GaugeMeter text-color-primary"\n                                 data-text="In"\n                                 data-size="';
              r += c(ctx_3.gaugeSize, ctx_3);
              r += '"\n                                 data-width="25"\n                                 data-percent="0"\n                                 data-label="Progress"\n                                 data-style="Full"\n                                 data-stripe="0"\n                                 data-animationstep="3"\n\n                                 data-animate_text_colors="1"\n                                 data-animate_gauge_colors="1"\n                                 data-color="#fafafa"\n                                 data-back="#fafafa"\n                                 data-theme="Red-Gold-Green">\n                            </div>\n                            ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        </div>\n                        <h4 class="text-align-center no-margin text-color-primary">Intervention Time</h4>\n                    </div>\n                </div>\n            </div>\n            <div class="block map-block no-margin no-padding">\n                <div id="map" style="width:100%;height:0vw;"></div>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            ';
      r += Template7Helpers.js_if.call(ctx_1, "this.request.status == 50 || this.request.status == 60", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            ';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.myRating, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n            <div class="block-title text-align-center">How satisfied are you with your experience today?</div>\n            ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n            <div class="block-title text-align-center">Your Rating</div>\n            ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            <div class="block text-align-center" @click="showRatingModal">\n                <div class="rating-widget ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.myRating, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 'rating-';
              r += c(ctx_3.myRating.rating, ctx_3);
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '">\n                    <div></div>\n                    <i class="icon material-icons">star</i>\n                    <i class="icon material-icons">star</i>\n                    <i class="icon material-icons">star</i>\n                    <i class="icon material-icons">star</i>\n                    <i class="icon material-icons">star</i>\n                </div>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.request.report_url, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="list links-list margin-5-0">\n                <ul>\n                    <li class="large-gray-link">\n                        <a class=""  href="#" @click="viewReport">\n                            View Report\n                        </a>\n                    </li>\n                </ul>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            <div class="active-services-container no-margin display-none">\n                <div class="active-service">\n                    <div class="active-service-content" style="border-top: none;">\n                        <div class="active-service-media">\n                            <i class="icon material-icons">access_time</i>\n                        </div>\n                        <div class="active-service-inner">\n                            <div class="active-service-description">\n                                <div class="bold">';
      r += c(ctx_1.request.status_label, ctx_1);
      r += '</div>\n                                <div class="">';
      r += c(ctx_1.request.location, ctx_1);
      r += '</div>\n                                <div class="">';
      r += c(ctx_1.request.equipment, ctx_1);
      r += '</div>\n                                <div class="">';
      r += c(ctx_1.request.problem, ctx_1);
      r += '</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="block-title text-color-black">Your service details</div>\n            <div class="list no-margin">\n                <ul>\n                    <li>\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Service no.</div>\n                                    ';
      r += c(ctx_1.request.id, ctx_1);
      r += '\n                                    ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.request.related_request_id, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                    (Previously ';
          r += c(ctx_2.request.related_request_id, ctx_2);
          r += ')\n                                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n\n                    <li>\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Location</div>\n                                    ';
      r += c(ctx_1.request.location, ctx_1);
      r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n\n                    <li>\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Unit</div>\n                                    ';
      r += c(ctx_1.request.equipment, ctx_1);
      r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n\n                    ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.request.problem, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <li>\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Problem</div>\n                                    ';
          r += c(ctx_2.request.problem, ctx_2);
          r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                    <li>\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Status</div>\n                                    ';
      r += c(ctx_1.request.status_label, ctx_1);
      r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n\n                    ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.request.technician, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <li>\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Assigned technician</div>\n                                    ';
          r += c(ctx_2.request.technician, ctx_2);
          r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.request.extra_cost, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <li>\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Extra cost</div>\n                                    ';
          r += c(ctx_2.request.extra_cost_formatted, ctx_2);
          r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                    ';
      r += Template7Helpers.js_if.call(ctx_1, "this.request.status == 50 || this.request.status == 60", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <li>\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Unit Operational?</div>\n                                    ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.request.system_operational, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 'Yes';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += 'No';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                    ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.request.whats_next, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                    <div class="item-footer">';
              r += c(ctx_3.request.whats_next, ctx_3);
              r += '</div>\n                                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    <li>\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Passenger was trapped?</div>\n                                    ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.request.person_trapped, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 'Yes';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += 'No';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.request.rating, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <li class="display-none">\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    Rating\n                                    <table class="width-100">\n                                        <tbody>\n                                        ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.request.ratings, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                        <tr>\n                                            <td class="item-footer">';
                  r += c(ctx_4.user, ctx_4);
                  r += '</td>\n                                            <td class="padding-left item-footer text-align-right">';
                  r += c(ctx_4.rating, ctx_4);
                  r += ' Stars</td>\n                                        </tr>\n                                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                                        <tr>\n                                            <td class="item-header">Avg.</td>\n                                            <th class="padding-left item-header text-align-right">';
              r += c(ctx_3.request.rating, ctx_3);
              r += '\n                                                Stars\n                                            </th>\n                                        </tr>\n                                        </tbody>\n                                    </table>\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    <li>\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Time report</div>\n                                    <div class="timeline margin-top-half no-margin-bottom no-padding">\n                                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.request.requested_at_formatted, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                        <div class="timeline-item">\n                                            <div class="timeline-item-date text-align-left">Scheduled</div>\n                                            <div class="timeline-item-divider bg-color-primary"></div>\n                                            <div class="timeline-item-content">';
          r += c(ctx_2.request.scheduled_at_formatted, ctx_2);
          r += '</div>\n                                        </div>\n                                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.request.informed_at_formatted, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                        <div class="timeline-item display-none">\n                                            <div class="timeline-item-date text-align-left">Informed</div>\n                                            <div class="timeline-item-divider bg-color-primary"></div>\n                                            <div class="timeline-item-content">';
          r += c(ctx_2.request.informed_at_formatted, ctx_2);
          r += '</div>\n                                        </div>\n                                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.request.arrived_at_formatted, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                        <div class="timeline-item">\n                                            <div class="timeline-item-date text-align-left">Arrived</div>\n                                            <div class="timeline-item-divider bg-color-primary"></div>\n                                            <div class="timeline-item-content">';
          r += c(ctx_2.request.arrived_at_formatted, ctx_2);
          r += '</div>\n                                        </div>\n                                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.request.departed_at_formatted, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                        <div class="timeline-item">\n                                            <div class="timeline-item-date text-align-left">Departed</div>\n                                            <div class="timeline-item-divider bg-color-primary"></div>\n                                            <div class="timeline-item-content">';
          r += c(ctx_2.request.departed_at_formatted, ctx_2);
          r += '</div>\n                                        </div>\n                                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.request.note_client, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <li>\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title" style="white-space: normal">\n                                    <div class="item-footer">Repair report</div>\n                                    ';
          r += c(ctx_2.request.note_client, ctx_2);
          r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                </ul>\n            </div>\n\n\n            ';
      r += Template7Helpers.js_if.call(ctx_1, "this.request.lineItems.length>0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="display-none block-title">Repair report</div>\n            <div class="display-none list no-margin">\n                <ul>\n                    ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.request.lineItems, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <li>\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    ';
              r += c(ctx_3.objectCode.name, ctx_3);
              r += '\n                                    <div class="item-footer">';
              r += c(ctx_3.causeCode.name, ctx_3);
              r += '</div>\n                                    <!--<div class="item-footer">';
              r += c(ctx_3.damageCode.name, ctx_3);
              r += '</div>-->\n                                    <!--<div class="item-footer">';
              r += c(ctx_3.manufacturer.name, ctx_3);
              r += '</div>-->\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                </ul>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            ';
      r += Template7Helpers.js_if.call(ctx_1, "this.request.maintenance_tasks_groups.length>0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="block-title">Maintenance Report</div>\n            <div class="list no-margin-top">\n                <ul>\n                    ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.request.maintenance_tasks_groups, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <li>\n                        <div class=" item-content">\n                            <div class="item-media">\n                                <i class="icon material-icons text-color-primary">check</i>\n                            </div>\n                            <div class="item-inner">\n                                <div class="item-title" style="white-space: normal;">\n                                    ';
              r += c(ctx_3.name, ctx_3);
              r += '\n                                    ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.maintenanceTasks, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                    <div class="item-footer">';
                  r += c(ctx_4.name, ctx_4);
                  r += '</div>\n                                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                </ul>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n<br/>\n<br/>\n<br/>\n<br/>\n<br/>\n<br/>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    